import { Link } from 'react-router-dom';

const categories = [
  {
    name: 'APPAREL',
    image: 'https://public.readdy.ai/ai/img_res/53769d2f9c41eae27da9494f2d3a6b73.jpg',
    link: '/apparel'
  },
  {
    name: 'FOOTWEAR',
    image: 'https://readdy.ai/api/search-image?query=premium%20black%20sneakers%20on%20dark%20concrete%20urban%20surface%20streetwear%20footwear%20editorial%20photography%20moody%20atmospheric%20lighting%20fashion%20product%20shot%20minimal%20aesthetic&width=800&height=600&seq=category-footwear-1&orientation=landscape',
    link: '/footwear'
  },
  {
    name: 'ACCESSORIES',
    image: 'https://readdy.ai/api/search-image?query=black%20snapback%20hats%20leather%20bags%20and%20silver%20jewelry%20arranged%20on%20dark%20surface%20streetwear%20accessories%20editorial%20flat%20lay%20photography%20moody%20lighting%20urban%20fashion%20minimal%20composition&width=800&height=600&seq=category-accessories-1&orientation=landscape',
    link: '/accessories'
  }
];

export default function ShopByCategory() {
  return (
    <section className="py-40 px-8 bg-[#0A0A0A]">
      <div className="max-w-[1600px] mx-auto">
        <div className="grid md:grid-cols-3 gap-6">
          {categories.map((category) => (
            <Link
              key={category.name}
              to={category.link}
              className="group relative h-[400px] rounded-2xl overflow-hidden"
            >
              <img
                src={category.image}
                alt={category.name}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent group-hover:from-black/95 transition-all duration-300"></div>
              
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
                <h3 className="text-5xl font-black text-white mb-4 tracking-tight">{category.name}</h3>
                <span className="text-white text-base font-medium flex items-center gap-2 group-hover:underline whitespace-nowrap">
                  SHOP NOW <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}